import React, { useState,useContext,useEffect } from "react";
import "./Accountpay.css";
import common from "../config/common.json"
import YourCurrentPlan from "./YourCurrentPlan";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import getGlobalVarContext from "../context/getGlobalVarContext";
import {useIntl} from 'react-intl';


function Accountpay({ plan,coupendata,prev_subscription_id ,userId}) {
  const [isLoading, setIsLoading] = useState(false);  
  const [OpenAccountpay, setOpenAccountpay] = useState(true);
  const [OpenYour_Current_plan, setYour_Current_plan] = useState(false);
  const [card_Naumber, setCard_Naumber] = useState("");
  const [expire_Date, setExpire_Date] = useState("");
  const [paymentSourceId, setPaymentSourceId] = useState("");
  const [cvv, setCvv] = useState("");
  const [apiError, setApiError] = useState("");
  const [checkRequiredField, setCheckRequiredField] = useState(false);
  const { globalVar} = useContext(getGlobalVarContext());
  const {email}= globalVar
  const intl = useIntl()
  function payByCard() {
    setIsLoading(true);
    setCheckRequiredField(true);
    if (card_Naumber !== "" && expire_Date !== null && cvv !== "") {
      getUserData();
    } else {
      setApiError(intl.formatMessage({id: "mustProvideAllDetalis"}));
      setIsLoading(false);
    }
  }

  async function getUserData() {
    var requestOptions = {
      method: "GET"
    };
    var res = await fetch(
      `${common.BASEURL}/user/details?email=${email !==null ?email:localStorage.getItem("email")}`,
      requestOptions
    );
    var response = await res.json();

    if (res.status === 404) {
  
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 200) {
      
      updatecard(
        response.msg.user_id,
        response.msg.plan,
        response.msg.first_name,
        response.msg.last_name
      );
    } else {
      setApiError(response.msg);
      setIsLoading(false);
    }
  }

  async function updatecard(
    user_id,
    planName,
    first_name,
    last_name
  ) {
    var date = expire_Date.split("/");

    if(!paymentSourceId && isNaN(card_Naumber) === true){
      setApiError(intl.formatMessage({id: "enterValidCardDetails"}));
      setIsLoading(false);
      return 0
    }
    if(isNaN(cvv) === true){
      setApiError(intl.formatMessage({id: "enterValidCvv"}));
      setIsLoading(false);
      return 0
    }
    if(date.length === 1){
      setApiError(intl.formatMessage({id: "enterValidDate"}));
      setIsLoading(false);
      return 0
    }
    var raw = {
      first_name: first_name,
      last_name: last_name,
      card_Number: card_Naumber,
      cvv: cvv,
      expiry_year: date[1],
      expiry_month: date[0],
      id: user_id
    };
    if(paymentSourceId){
      raw["card"]=true
      raw["payment_source_id"]=paymentSourceId
    }

    var requestOptions = {
      method: "POST",
      body: JSON.stringify(raw)
    };
    var res = await fetch(`${common.BASEURL}/user/update/card`, requestOptions);
    var response= await res.json();
    if (res.status === 404) {
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 200) {
      subscription(user_id, planName);
    } else {
      setApiError(response.msg);
      setIsLoading(false);
    }
  }

  async function suscribapigetway(subscription_id) {
    var date = expire_Date.split("/");
    var raw = JSON.stringify({
      email: localStorage.getItem("email"),
      card: card_Naumber,
      cvv: cvv,
      expiry_year: date[1],
      expiry_month: date[0],
      subscription_id: subscription_id,
      k_usernumber: localStorage.getItem("k_username"),
      planId:plan
    });
    var requestOptions = {
      method: "POST",
      body: raw
    };
    var res = await fetch(
      `${common.BASEURL}/user/update/subscription`,
      requestOptions
    );
    var response = await res.json();
    if (res.status === 404) {
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 200) {
      // console.log(response.msg);
      document.getElementById("plan_type").innerHTML =intl.formatMessage({id: "viewPlanInAccountPage"});
      setOpenAccountpay(false);
      setYour_Current_plan(true);
      setIsLoading(false);
    } else {
      setApiError(response.msg);
      setIsLoading(false);
    }
  }

  async function subscription(user_id, planName) {
    var newPlan;
    if (planName == null || planName || undefined) {
      newPlan = plan;
    }
  
    var raw = {
      id: user_id,
      prev_subscription_id:prev_subscription_id,
      plan_id: newPlan
    };
    if(coupendata !== "" || coupendata !== null || coupendata !==undefined){
      raw["CouponIds"]=coupendata
    }
    
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(raw)
    };
    var res = await fetch(
      `${common.BASEURL}/user/coupon/subscription`,
      requestOptions
    );
    var response = await res.json();
    if (res.status === 404) {
      
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 200) {
      
      suscribapigetway(response.msg.subscription.id);
    } else {
      
      setApiError(response.msg);
      setIsLoading(false);
    }
  }

  async function getUserPay() {
    var raw = JSON.stringify({
      email: localStorage.getItem("email"),
      customerId: userId,
    });
    var requestOptions = {
      method: "POST",
      body: raw,
    };
    try {
      var res = await fetch(
        `${common.BASEURL}/user/card/info`,
        requestOptions
      );
      res = await res.json();
      if(res.msg.length !== 0 && res.msg[0].payment_source_id){
        setPaymentSourceId(res.msg[0].payment_source_id)
        setCard_Naumber(res.msg[0].masked_number)
        setExpire_Date(`${res.msg[0].expiry_month}/${res.msg[0].expiry_year}`)
      }
    } catch (error) {
      console.log("error")
    }
  }
  useEffect(() => {
    if(userId){
      getUserPay()
    }
  }, [])

  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        !OpenYour_Current_plan &&
        OpenAccountpay && (
          <>
            <div className="accountpopup">
              <div className="accountpopup_form">
                <h4>{intl.formatMessage({id: "paymentDetailsInfo" })}</h4>
                <div className="center">{apiError}</div>
                <p>{intl.formatMessage({id: "lableCardNumber" })}</p>
                <input
                  type="text"
                  className={
                    checkRequiredField && card_Naumber === "" ? "borderRed" : ""
                  }
                  value={card_Naumber}
                  autoComplete="off"
                  disabled={paymentSourceId?true:false}
                  onChange={e => {
                    setCard_Naumber(e.target.value);
                    setApiError("");
                  }}
                  name={intl.formatMessage({id: "lableCardNumber" })}
                  placeholder={intl.formatMessage({id: "lableCardNumber" })}
                />
                
                <div className="accountpopup_splitinput">
                  <div>
                    <label>{intl.formatMessage({id: "lableExpireDate" })}</label>
                    <input
                      className={
                        checkRequiredField && expire_Date === ""
                          ? "borderRed"
                          : ""
                      }
                      value={expire_Date}
                      autoComplete="off"
                      disabled={paymentSourceId?true:false}
                      onChange={e => {
                        setExpire_Date(e.target.value);
                        setApiError("");
                      }}
                      name={intl.formatMessage({id: "lableExpireDate" })}
                      type="text"
                      placeholder={intl.formatMessage({id: "placeHolderForExpireDate" })}
                    />
                  </div>
                  <div>
                    <label>{intl.formatMessage({id: "lableCvv" })}</label>
                    <input
                      className={
                        checkRequiredField && cvv === ""
                          ? "borderRed"
                          : "" && "bordergreen"
                      }
                      type="password"
                      value={cvv}
                      autoComplete="off"
                      onChange={e => {
                        setCvv(e.target.value);
                        setApiError("");
                      }}
                      name={intl.formatMessage({id: "lableCvv" })}
                      placeholder={intl.formatMessage({id: "placeHolderForCvv" })}
                    />
                  </div>
                </div>
               
                <button className="accountpopup_button" onClick={payByCard}>
                {intl.formatMessage({id: "paymentButton" })}
                </button>
              </div>
            </div>
          </>
        )
      )}
      {/* ) */}
      {OpenYour_Current_plan && !OpenAccountpay && (
        // eslint-disable-next-line react/jsx-pascal-case
        <YourCurrentPlan plan={plan} />
      )}
    </div>
  );
}
export default Accountpay;